// Cross-subdomain URL helpers. One build serves both domains:
//   sparkcue.co        -> marketing (CTAs point to the app subdomain)
//   app.sparkcue.co    -> the application (logo points back to marketing)
// Preview/localhost stays same-origin so the dev preview keeps working.

const PROD_APP = "https://app.sparkcue.co";
const PROD_MARKETING = "https://sparkcue.co";

const host = () => (typeof window !== "undefined" ? window.location.hostname : "");

export const isAppHost = () => host().startsWith("app.");

// Where "Start Free / Launch App / Open App" should go.
export const getAppUrl = () => {
  const h = host();
  if (h === "sparkcue.co" || h === "www.sparkcue.co") return PROD_APP; // marketing domain -> app subdomain
  return "/app"; // preview, localhost, or already on the app host
};

// Where the in-app logo should return users.
export const getMarketingUrl = () => {
  if (isAppHost()) return PROD_MARKETING; // app subdomain -> marketing
  return "/"; // preview/localhost
};
